<!--
    Summary:
        卓信化验所简介
    ChangeLog:
        Labbor on 2020/2/21 added
-->
<template>
  <div class="v-about-fclab">
    <banner>
      <img src="../../assets/images/about/Header_1920x380_about-us.jpg"/>
      <div slot="title">{{$t('aboutFCLAB.Title')}}</div>
    </banner>

    <!-- 卓信化验所简介 -->
    <card class="about">
      <div slot="title">{{$t('aboutFCLAB.FirstChoiceMedicalLaboratory')}}</div>
      <p class="detail">{{$t('aboutFCLAB.FirstChoiceMedicalLaboratoryDetail')}}</p>
     
    </card>

    <card class="mission">
      <div slot="title">{{$t('aboutFCLAB.Mission')}}</div>
      <div class="right">
            <h2 class="title">{{$t('aboutFCLAB.MissionDetail')}}</h2>
          </div>

      <div class="p1"><h2 class="h2" style="text-align: center; color: #e699b2; text-shadow: 1px 1px 2px #ffffff;">{{$t('aboutFCLAB.MissionDetail2')}}</h2></div>
      <p class="detail2">{{$t('aboutFCLAB.MissionDetail3')}}</p>
      <div class="p1"><h2 class="h2" style="text-align: center; color: #546c97; text-shadow: 1px 1px 2px #ffffff;">{{$t('aboutFCLAB.MissionDetail4')}}</h2></div>
      <p class="detail2">{{$t('aboutFCLAB.MissionDetail5')}}</p>
      <div class="p1"><h2 class="h2" style="text-align: center; color: #5ec3b5; text-shadow: 1px 1px 2px #ffffff;">{{$t('aboutFCLAB.MissionDetail6')}}</h2></div>
      <p class="detail2">{{$t('aboutFCLAB.MissionDetail7')}}</p>
      <div class="p1"><h2 class="h2" style="text-align: center; color: #f1c480; text-shadow: 1px 1px 2px #ffffff;">{{$t('aboutFCLAB.MissionDetail8')}}</h2></div>
      <p class="detail2">{{$t('aboutFCLAB.MissionDetail9')}}</p>
      <div class="p1"><h2 class="h2" style="text-align: center; color: #e699b2; text-shadow: 1px 1px 2px #ffffff;">{{$t('aboutFCLAB.MissionDetail10')}}</h2></div>
      <p class="detail2">{{$t('aboutFCLAB.MissionDetail11')}}</p>
     </card>

     <card class="mission">
      <div slot="title">{{$t('aboutFCLAB.MissionDetail12')}}</div>
      <p class="detail2">{{$t('aboutFCLAB.MissionDetail13')}}</p>
      <p class="detail2">{{$t('aboutFCLAB.MissionDetail14')}}</p>
     </card>
     <card class="mission">
      <div slot="title">{{$t('aboutFCLAB.MissionDetail15')}}</div>
      <p class="detail2">{{$t('aboutFCLAB.MissionDetail16')}}</p>
      <p class="detail2">{{$t('aboutFCLAB.MissionDetail17')}}</p>
     </card>

      <card class="mission">
      <div slot="title">{{$t('aboutFCLAB.MissionDetail18')}}</div>
      <p class="detail2">{{$t('aboutFCLAB.MissionDetail19')}}</p>
      <p>&nbsp;</p>
      <p class="detail2">{{$t('aboutFCLAB.MissionDetail20')}}</p>
      <p>&nbsp;</p>
      <p class="detail2">{{$t('aboutFCLAB.MissionDetail21')}}</p>
      <p>&nbsp;</p>
      <p class="detail2">{{$t('aboutFCLAB.MissionDetail22')}}</p>
      <p>&nbsp;</p>
      <p class="detail2">{{$t('aboutFCLAB.MissionDetail23')}}</p>
     </card>

      <card class="mission">
      <div slot="title">{{$t('aboutFCLAB.MissionDetail24')}}</div>
      <p class="detail2">{{$t('aboutFCLAB.MissionDetail25')}}</p>
     </card>

    
  </div>
</template>

<script>
  import banner from '@/components/banner'
  import card from '@/components/card'

  export default {
    components: {
      banner,
      card
    },
    data() {
      return {}
    },
    methods: {},
  }
</script>

<style scoped lang="scss">
  .v-about-us {
    
    img {
      width: 100%;
    }

    

    .about{
      background-color: rgba(54,141,167,0.15);
      padding-bottom: 30px;
    }
    .mission{
      background-image: url("../../assets/images/about/About_1920x800-01.jpg");
      background-position: 50% 300px;
      padding-bottom: 30px;
    }
    .core-culture {
      margin-bottom: 48px;
      .c {
        display: flex;
        justify-content: space-between;
        .box{
          letter-spacing: 1px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 48%;
          .right{
            flex-grow: 1;
            .title{
              color: #368da7;
              font-size: 28px;
              font-style: normal;
              font-weight: 700;
              text-transform: none;
              margin: 0;
              line-height: 1.384615384615385em;
            }
            .detail{
              color: #3a3a3a;
              font-size: 16px;
              line-height: 24px;
              font-style: normal;
              font-weight: 400;
            }
          }
          img{
            width: 78px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/about/about-fclab.vue